import type { RoutineLibraryItem } from '@littlebird/sdk';

const RECOMMENDED_ROUTINE_LIMIT = 3;

export function pickRecommendedRoutines(
  items: RoutineLibraryItem[],
  suggestedSlugs: string[] = [],
  limit = RECOMMENDED_ROUTINE_LIMIT
): RoutineLibraryItem[] {
  const bySlug = new Map(items.map((item) => [item.id, item]));
  return suggestedSlugs
    .map((slug) => bySlug.get(slug))
    .filter((item): item is RoutineLibraryItem => item !== undefined)
    .slice(0, limit);
}

export function buildFirstRunChatMessage(
  summary: string,
  suggestedSlugs: string[]
): string {
  if (suggestedSlugs.length === 0) return summary;

  const routinesBlock = [
    '```routines',
    ...suggestedSlugs.slice(0, RECOMMENDED_ROUTINE_LIMIT),
    '```',
  ].join('\n');

  return [summary, routinesBlock].join('\n\n');
}
